'use strict'

import config from './config.mjs';
__webpack_public_path__ = config.javaScriptDirectoryPath;

import $ from 'jquery';
import './components/Header/Header.mjs';
import './components/FormCommon.mjs';

const $backToTop = $('.back-to-top__wrapper');
if ($backToTop.length) {
    import('./components/BackToTop.mjs');
}

const $video = $('.video');
if ($video.length) {
    import('./components/Video.mjs');
}

const $colIconText = $('.collection-icon-text__slider.swiper');
if ($colIconText.length) {
    import('./components/CollectionIconText.mjs');
}

const $colImageSmall = $('.collection-image-small__slider.swiper');
if ($colImageSmall.length) {
    import('./components/CollectionImageSmall.mjs');
}

const $colImageMedium = $('.collection-image-medium__slider.swiper');
if ($colImageMedium.length) {
    import('./components/CollectionImageMedium.mjs');
}

const $teaserHero = $('.teaser-hero.swiper');
if ($teaserHero.length) {
    import('./components/TeaserHero.mjs');
}

const $collectionIconNumber = $('.collection-icon-number');
if ($collectionIconNumber.length) {
    import('./components/CollectionIconNumber.mjs');
}

const $teaserImageMasonries = $('.teaser-image .grid');
if ($teaserImageMasonries.length) {
    import('./components/TeaserImage.mjs');
}

const $dynamicList = $('.dl');
if ($dynamicList.length) {
    import('./components/DynamicList.mjs');
}

const $tableElements = $('.table-component');
if ($tableElements.length) {
    import('./components/Table.mjs');
}

const $formValidationElements = $('.js-form-validation');
const $inputmodeEls = $('input[inputmode]');
if ($formValidationElements.length || $inputmodeEls.length) {
    if ($formValidationElements.length) {
        import('./components/FormValidation.mjs')
            .then((fvModule) => {
                fvModule.initGlobalFormValidation();
            });
    } else {
        import('./components/FormValidation.mjs')
            .then((fvModule) => {
                fvModule.initInputmode();
            });
    }
}

const $imageZoom = $('.image-zoom');
if ($imageZoom.length) {
    import('./components/ImageZoom.mjs');
}

const $pswq = $('.js-pswq');
if ($pswq.length) {
    import('./components/PlantsSearch.mjs');
}

const $searchResult = $('.js-search-result');
if ($searchResult.length) {
    import('./components/SearchResult.mjs');
}

const $servicePhone = $('.service-phone__select');
if ($servicePhone.length) {
    import('./components/ServicePhoneSelection.mjs');
}

const $filter = $('.filter__input');
if ($filter.length) {
    import('./components/Filter.mjs');
}

const $tickers = $('.js-ticker');
if ($tickers.length) {
    import('./components/TickerMarquee.mjs');
}

const $incidentModals = $('.js-incident-modal');
if ($incidentModals.length) {
    import('./components/IncidentModal.mjs');
}

const $accordion = $('.accordion');
if ($accordion.length) {
    import('./components/Accordion.mjs');
}

const $tabBar = $('.tab-bar__slider.swiper');
if ($tabBar.length) {
    import('./components/TabBar.mjs');
}

const $autocompleteInput = $('.js-search-autocomplete');
if ($autocompleteInput.length) {
    (async function () {
        await import('./libraries/JQueryUiCustom.mjs');
        await import('./components/SearchWithAutocomplete.mjs');
    })();
}

const $waterPressureSearch = $('.water-pressure');
if ($waterPressureSearch.length) {
    import('./components/WaterPressureSearch.mjs');
}

const $waterConsumptionCalculator = $('.water-consumption-calculator');
if ($waterConsumptionCalculator.length) {
    import('./components/WaterConsumptionCalculator.mjs');
}

const $kununu = $('.js-kununu');
if ($kununu.length) {
  import('./components/Kununu.mjs');
}

const $popoverEls = $('[data-bs-toggle="popover"]');
const $tooltipEls = $('[data-bs-toggle="tooltip"]');
if ($popoverEls.length || $tooltipEls.length) {
    import('./components/TooltipPopover.mjs')
        .then((tpModule) => {
            if ($popoverEls.length) {
                tpModule.initTooltipOrPopover('popover');
            }
            if ($tooltipEls.length) {
                tpModule.initTooltipOrPopover('tooltip');
            }
        });
}

if($('.js-cookie-consent-tool').length) {
  import('./components/CookieConsentTool.mjs')
}

const $contactForm = $('.js-contact-form');
if($contactForm.length) {
  import('./components/ContactForm.mjs');
}

/*
 * Something async
 */
// (async () => {
//   const $example = $('.example');
//   if ($example.length) {
//     const {AsyncExample} = await import('./modules/AsyncExample.mjs');
//
//     AsyncExample.run();
//   }
// })();
